import AdventureHomePage from "./AdventureHomePage";

export default AdventureHomePage;
